import KidItem from "./KidItem.jsx";

export default KidItem;